import React, { useState, useLayoutEffect } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FadeIn from "@/components/FadeIn";
import ExamplePhotos from "@/components/ExamplePhotos";
import UploadForm from "@/components/upload/UploadForm";
import ThankYouScreen from "@/components/upload/ThankYouScreen";
import { supabase } from "@/lib/supabase";

const Upload = () => {
  const [searchParams] = useSearchParams();
  const params = useParams<{ brandSlug?: string }>();
  const brandSlug = params.brandSlug || "";
  const orderId = searchParams.get("orderId") || "";

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [brand, setBrand] = useState<{ id: string; name: string } | null>(null);

  useLayoutEffect(() => {
    const fetchBrand = async () => {
      console.log("Fetching brand for slug:", brandSlug);

      // First try to find by unique_upload_slug
      const { data: brandBySlug, error: slugError } = await supabase
        .from("brands")
        .select("id, name")
        .eq("unique_upload_slug", brandSlug)
        .single();

      if (brandBySlug) {
        console.log("Found brand by slug:", brandBySlug);
        setBrand(brandBySlug);
        return;
      }

      // If not found by slug, try to find by ID-based slug format
      const parts = brandSlug.split('-');
      if (parts.length > 1) {
        const potentialId = parts[parts.length - 1];
        console.log("Trying to find brand by ID:", potentialId);

        const { data: brandById } = await supabase
          .from("brands")
          .select("id, name")
          .eq("id", potentialId)
          .single();

        if (brandById) {
          console.log("Found brand by ID:", brandById);
          setBrand(brandById);
          return;
        }
      }

      console.error("No brand found for slug:", brandSlug);
    };

    if (brandSlug) {
      fetchBrand();
    }
  }, [brandSlug]);

  const handleSubmitSuccess = () => {
    setIsSubmitted(true);
  };

  return (
    <>
      <Navbar />
      <main className="min-h-screen py-8 md:py-16">
        <div className="container max-w-3xl px-4 md:px-6">
          {!isSubmitted ? (
            <FadeIn>
              <div className="space-y-8">
                <UploadForm brand={brand} orderId={orderId} onSubmitSuccess={handleSubmitSuccess} />

                <ExamplePhotos />
              </div>
            </FadeIn>
          ) : (
            <ThankYouScreen />
          )}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Upload;
